import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { Rating } from 'src/features/product-card/NerdWalletRating/Rating';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from '../ColumnContext';
import { RatingContainer } from '../ProductCardWithStickyHeader/components/Rating.container';
import { CommonSkeleton } from './components/CommonSkeleton';
export function RatingSkeleton() {
  const $ = _c(6);
  const {
    index
  } = useCreditCardCompareColumnContext();
  const t0 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "flex";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      display: {
        xs: t0,
        md: "flex"
      }
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box display="flex"><Rating testid="skeleton-rating-stars-container" value={5} color="#D8D9DA" gap="5px" size="16px" additionalStyles={{
        alignSelf: "center",
        marginRight: "5px"
      }} /><CommonSkeleton width="1.25rem" height="1.75rem" data-testid="skeleton-rating-number-container" /></Box>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Box display="flex"><CommonSkeleton width="8rem" height="1.75rem" sx={{
        mr: "5px"
      }} data-testid="skeleton-nerdwallet-rating-container" /><CommonSkeleton width="1rem" height="1.75rem" data-testid="skeleton-rating-tooltip-container" /></Box>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <RatingContainer additionalProps={t1}>{t2}{t3}</RatingContainer>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}